import {
  getMessaging,
  getToken as getTokenF,
  isSupported,
} from 'firebase/messaging'
import { config } from 'src/utils/config'
import { app } from './app'

export async function getFirebaseMessaging() {
  const supported = await isSupported()
  return supported ? getMessaging(app) : null
}

export async function getFirebaseToken() {
  const messaging = await getFirebaseMessaging()
  if (!messaging) return
  return getTokenF(messaging, {
    serviceWorkerRegistration: await navigator.serviceWorker.ready,
    vapidKey: config.firebase.vapidKey,
  })
}
